import React from 'react';
import { GlassGradient, GlassPanel, Handle, BattenteTriangleFill, AntaRibaltaFill, VasistasFill, FixedMark, SlidingArrow, BilicoH, BilicoV } from './primitives';

export const shutter = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full">
    <rect x={8} y={8} width={40} height={84} fill="#E0D5C8" stroke="#333" strokeWidth="1" />
    {[0,1,2,3,4,5,6,7,8].map(i => (<line key={`l${i}`} x1={12} y1={16+i*9} x2={44} y2={16+i*9} stroke="#B09878" strokeWidth="1.5" />))}
    <rect x={52} y={8} width={40} height={84} fill="#E0D5C8" stroke="#333" strokeWidth="1" />
    {[0,1,2,3,4,5,6,7,8].map(i => (<line key={`r${i}`} x1={56} y1={16+i*9} x2={88} y2={16+i*9} stroke="#B09878" strokeWidth="1.5" />))}
    <rect x={4} y={4} width={92} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const shutter1Anta = () => (
  <svg viewBox="0 0 70 100" className="w-full h-full">
    <rect x={10} y={8} width={50} height={84} fill="#E0D5C8" stroke="#333" strokeWidth="1" />
    {[0,1,2,3,4,5,6,7,8].map(i => (<line key={`s${i}`} x1={14} y1={16+i*9} x2={56} y2={16+i*9} stroke="#B09878" strokeWidth="1.5" />))}
    <rect x={6} y={4} width={58} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const shutterScorrevole = () => (
  <svg viewBox="0 0 120 100" className="w-full h-full">
    <rect x={8} y={8} width={50} height={84} fill="#E0D5C8" stroke="#333" strokeWidth="1" />
    {[0,1,2,3,4,5,6,7,8].map(i => (<line key={`sl${i}`} x1={12} y1={16+i*9} x2={54} y2={16+i*9} stroke="#B09878" strokeWidth="1.5" />))}
    <rect x={62} y={8} width={50} height={84} fill="#E0D5C8" stroke="#333" strokeWidth="1" />
    {[0,1,2,3,4,5,6,7,8].map(i => (<line key={`sr${i}`} x1={66} y1={16+i*9} x2={108} y2={16+i*9} stroke="#B09878" strokeWidth="1.5" />))}
    <rect x={4} y={4} width={112} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <SlidingArrow x={40} y={50} direction="right" length={25} />
  </svg>
);

export const shutter3Ante = () => (
  <svg viewBox="0 0 120 100" className="w-full h-full">
    <rect x={8} y={8} width={32} height={84} fill="#E0D5C8" stroke="#333" strokeWidth="1" />
    {[0,1,2,3,4,5,6,7,8].map(i => (<line key={`a${i}`} x1={11} y1={16+i*9} x2={37} y2={16+i*9} stroke="#B09878" strokeWidth="1.5" />))}
    <rect x={44} y={8} width={32} height={84} fill="#E0D5C8" stroke="#333" strokeWidth="1" />
    {[0,1,2,3,4,5,6,7,8].map(i => (<line key={`b${i}`} x1={47} y1={16+i*9} x2={73} y2={16+i*9} stroke="#B09878" strokeWidth="1.5" />))}
    <rect x={80} y={8} width={32} height={84} fill="#E0D5C8" stroke="#333" strokeWidth="1" />
    {[0,1,2,3,4,5,6,7,8].map(i => (<line key={`c${i}`} x1={83} y1={16+i*9} x2={109} y2={16+i*9} stroke="#B09878" strokeWidth="1.5" />))}
    <rect x={4} y={4} width={112} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const shutter4Ante = () => (
  <svg viewBox="0 0 140 100" className="w-full h-full">
    <rect x={8} y={8} width={28} height={84} fill="#E0D5C8" stroke="#333" strokeWidth="1" />
    {[0,1,2,3,4,5,6,7,8].map(i => (<line key={`a${i}`} x1={11} y1={16+i*9} x2={33} y2={16+i*9} stroke="#B09878" strokeWidth="1.5" />))}
    <rect x={40} y={8} width={28} height={84} fill="#E0D5C8" stroke="#333" strokeWidth="1" />
    {[0,1,2,3,4,5,6,7,8].map(i => (<line key={`b${i}`} x1={43} y1={16+i*9} x2={65} y2={16+i*9} stroke="#B09878" strokeWidth="1.5" />))}
    <rect x={72} y={8} width={28} height={84} fill="#E0D5C8" stroke="#333" strokeWidth="1" />
    {[0,1,2,3,4,5,6,7,8].map(i => (<line key={`c${i}`} x1={75} y1={16+i*9} x2={97} y2={16+i*9} stroke="#B09878" strokeWidth="1.5" />))}
    <rect x={104} y={8} width={28} height={84} fill="#E0D5C8" stroke="#333" strokeWidth="1" />
    {[0,1,2,3,4,5,6,7,8].map(i => (<line key={`d${i}`} x1={107} y1={16+i*9} x2={129} y2={16+i*9} stroke="#B09878" strokeWidth="1.5" />))}
    <rect x={4} y={4} width={132} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const shutterScorrevoleSx = () => (
  <svg viewBox="0 0 120 100" className="w-full h-full">
    <rect x={8} y={8} width={50} height={84} fill="#E0D5C8" stroke="#333" strokeWidth="1" />
    {[0,1,2,3,4,5,6,7,8].map(i => (<line key={`sl${i}`} x1={12} y1={16+i*9} x2={54} y2={16+i*9} stroke="#B09878" strokeWidth="1.5" />))}
    <rect x={62} y={8} width={50} height={84} fill="#E0D5C8" stroke="#333" strokeWidth="1" />
    {[0,1,2,3,4,5,6,7,8].map(i => (<line key={`sr${i}`} x1={66} y1={16+i*9} x2={108} y2={16+i*9} stroke="#B09878" strokeWidth="1.5" />))}
    <rect x={4} y={4} width={112} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <SlidingArrow x={80} y={50} direction="left" length={25} />
  </svg>
);

export const shutterScorrevoleDx = () => (
  <svg viewBox="0 0 120 100" className="w-full h-full">
    <rect x={8} y={8} width={50} height={84} fill="#E0D5C8" stroke="#333" strokeWidth="1" />
    {[0,1,2,3,4,5,6,7,8].map(i => (<line key={`sl${i}`} x1={12} y1={16+i*9} x2={54} y2={16+i*9} stroke="#B09878" strokeWidth="1.5" />))}
    <rect x={62} y={8} width={50} height={84} fill="#E0D5C8" stroke="#333" strokeWidth="1" />
    {[0,1,2,3,4,5,6,7,8].map(i => (<line key={`sr${i}`} x1={66} y1={16+i*9} x2={108} y2={16+i*9} stroke="#B09878" strokeWidth="1.5" />))}
    <rect x={4} y={4} width={112} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <SlidingArrow x={40} y={50} direction="right" length={25} />
  </svg>
);

export const scuro1Anta = () => (
  <svg viewBox="0 0 70 100" className="w-full h-full">
    <rect x={10} y={8} width={50} height={84} fill="#C8B8A0" stroke="#333" strokeWidth="1" />
    <line x1={35} y1={42} x2={35} y2={58} stroke="#8B7355" strokeWidth="2" />
    <rect x={6} y={4} width={58} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const scuro2Ante = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full">
    <rect x={8} y={8} width={40} height={84} fill="#C8B8A0" stroke="#333" strokeWidth="1" />
    <line x1={28} y1={42} x2={28} y2={58} stroke="#8B7355" strokeWidth="2" />
    <rect x={52} y={8} width={40} height={84} fill="#C8B8A0" stroke="#333" strokeWidth="1" />
    <line x1={72} y1={42} x2={72} y2={58} stroke="#8B7355" strokeWidth="2" />
    <rect x={4} y={4} width={92} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

